import {FCWithHTMLAttributes} from "../types/reactTypes";
import Size from "../util/Size";
import clsMerge from "../util/clsMerge";

// TODO: Refactor to use the `classes` pattern
export interface ContainerProps {
	size?: Size;
	outerClassName?: string;
	outerChildren?: React.ReactNode;
	// Used for when two containers are stacked on top of each other
	lessTopPadding?: boolean;
}

export const CONTAINER_X_PADDING_CLASS_NAMES = "px-4 md:px-10 lg:px-30";

const SIZE_CLASS_NAMES: Record<Size, string> = {
	[Size.xs]: "max-w-screen-xs",
	[Size.sm]: "max-w-screen-sm",
	[Size.md]: "max-w-screen-md",
	[Size.lg]: "max-w-screen-lg",
	[Size.xl]: "max-w-screen-xl",
	[Size.xxl]: "max-w-screen-2xl",
};

/**
 * Component which renders a container with a max width.
 *
 * The `size` prop determines the max width of the container, based on the
 * screen width breakpoints defined in the Tailwind config.
 *
 * Because the implementation consists of two nested elements, the component accepts
 * both a `className` and `outerClassName` prop, which are applied to the inner
 * and outer divs, respectively, as well as an `outerChildren` prop.
 */
const Container: FCWithHTMLAttributes<ContainerProps> = ({
	size = Size.xl,
	className = "",
	outerClassName = "",
	outerChildren,
	lessTopPadding,
	...props
}) => (
	<div className={outerClassName}>
		{outerChildren}
		<div
			className={clsMerge(
				"mx-auto scroll-m-8 py-10 md:py-20",
				CONTAINER_X_PADDING_CLASS_NAMES,
				SIZE_CLASS_NAMES[size],
				lessTopPadding && "lg:pt-10",
				className
			)}
			{...props}
		/>
	</div>
);

export default Container;
